module.exports = __webpack_public_path__ + "static/royal-grimoire-76868ec4fa55a3a66efbab522a5bd4be.png";